/*
 * Special Dom Appender for specific cases where appending requires extra handling.
 */
export default class DomAppender {
    /*
     * By creating a new <script> element(createElement), browsers treat it as a fresh script.
     * Its code executes immediately when appended to the DOM.
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement#dynamically_importing_scripts
     */
    public static appendScript(target: HTMLElement, elementHTML: HTMLScriptElement): void {
        const newScript: HTMLScriptElement = document.createElement<HTMLScriptElement>('script');

        Array.from(elementHTML.attributes).forEach((attr) => {
            newScript.setAttribute(attr.name, attr.value);
        });

        newScript.text = elementHTML.text;

        target.appendChild(newScript);
    }
}
